import React from 'react'
import dateFormat from 'dateformat'

export default ({ date }) => <span>{dateFormat(date, 'dd.mm.yyyy HH:MM')}</span>
